import axios from 'axios'
import QueryParamsUtil from 'api/utils/query-params-util'

const API_PATH = 'api/v2/admins/sellers/products'

const SellerProductApiV2 = {
  /**
   * Get list of `Seller::Product` and its associations
   * Invoke from `GET api/v2/admins/sellers/products`
   * @param {object} tableState - ReactTable final state
   * @param {object} additionalFilters - A plain object to get customize filters outside `tableState`
   */
  get: async ({ tableState, additionalFilters }) => {
    const params = QueryParamsUtil.format(tableState, additionalFilters)
    const path   = API_PATH

    const response = await axios.get(path, { params })
    return response
  },

  /**
   * Get the details of a single `Seller::Product`
   * Invoke from `GET api/v2/admins/sellers/products/:id`
   * @param {number} id - ID of Seller Product
   */
  get_single: async (id) => {
    const path     = `${API_PATH}/${id}`
    const response = await axios.get(path)
    return response
  },

  /**
   * Delete Seller Product before going live
   * @param {number} id - selected Seller Product ID
   */
  destroy: async (id) => {
    const path = `${API_PATH}/${id}`

    const response = await axios.delete(path)
    return response
  },


  /**
   * Complete the photo upload process in Seller Product
   * @param {number} id - Seller Product ID
   * @param {boolean} defect_photo_uploaded - Defect Photo Uploaded
   */
  photo_upload_complete: async ({ id, defect_photo_uploaded }) => {
    const path = `${API_PATH}/${id}/photo_upload_complete`

    const response = await axios.patch(path, {
      defect_photo_uploaded: defect_photo_uploaded
    })
    return response
  },

  /**
   * Making Seller Products live
   * @param {array} ids - List of Seller Product ID
   */
  make_live: async ({ ids }) => {
    const path = `${API_PATH}/make_live`
    const body = {
      seller_product: {
        ids: ids
      }
    }

    const response = await axios.patch(path, body)
    return response
  }
}

export default SellerProductApiV2
